import { render, staticRenderFns } from "./banner-od-accepted.vue?vue&type=template&id=6e2accc5"
import script from "./banner-od-accepted.vue?vue&type=script&lang=js"
export * from "./banner-od-accepted.vue?vue&type=script&lang=js"
import style0 from "./banner-od-accepted.vue?vue&type=style&index=0&id=6e2accc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports